/**
 * Anti-cheat (paste/copy/cut blocking + scenario copy-block) is ON unless the
 * build explicitly sets VITE_ANTICHEAT_ENABLED="false". Used to relax blocking
 * on staging during testing; production builds leave it unset → enabled.
 */
export const ANTICHEAT_ENABLED: boolean = import.meta.env["VITE_ANTICHEAT_ENABLED"] !== "false";
